module.exports = __webpack_public_path__ + "static/img/zk.1dbb3020.png";